import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CompanyI } from '../../../models/company';
import { validateAllFormFields } from '../../utils/form-utils';
import { SessionCompanyService } from '../../../online/administration/my-company/service/session-company.service';
import { AlertMixin } from '../../../mixins/alert/alert.mixin';
import { MixinBase } from '../../../mixins/crud/MixinBase';
import { MessageBus } from '../../../messaging/MessageBus';
import { Configuration } from '../../../constant/configuration';

@Component({
    selector: 'app-company-active-legal-professionals-form',
    templateUrl: './company-active-legal-professionals-form.component.html',
    styleUrls: ['./company-active-legal-professionals-form.component.scss']
})
export class CompanyActiveLegalProfessionalsFormComponent extends AlertMixin(MixinBase) implements OnInit {
    @Input() submitLabel = 'global.action.save';
    @Input() targetCompany: CompanyI;
    @Output() submittedEvent = new EventEmitter<number>();
    @Output() resetEvent = new EventEmitter<void>();
    formGroup: UntypedFormGroup;
    company: CompanyI;

    constructor(
        messageBus: MessageBus,
        configuration: Configuration,
        private sessionCompanyService: SessionCompanyService,
        private formBuilder: UntypedFormBuilder
    ) {
        super();
        this.initAlertMixin(messageBus.channel(configuration.messageBusChannels.ALERT_CHANNEL));
    }

    ngOnInit(): void {
        if (!this.targetCompany) {
            void this.loadCompany();
        } else {
            this.company = this.targetCompany;
        }
        this.initForm();
    }

    async loadCompany(): Promise<void> {
        this.company = await this.sessionCompanyService.getSessionCompany();
        this.initForm();
    }

    initForm(): void {
        const { required, pattern } = Validators;
        this.formGroup = this.formBuilder.group({
            activeLegalProfessionals: [this.company?.numberOfLegalProfessionals || 0, [required, pattern('^[0-9]+$')]]
        });
    }

    onSubmit(): void {
        if (this.formGroup.invalid) {
            validateAllFormFields(this.formGroup);
        } else {
            this.submittedEvent.emit(this.formGroup.get('activeLegalProfessionals').value as number);
        }
    }

    onReset(e: Event): void {
        e.preventDefault();
        this.formGroup.reset();
        this.initForm();
        this.resetEvent.emit();
    }
}
